import { applyMiddleware, createStore } from 'redux';
import { createRootReducer } from './RootReducer';
import { createEpicMiddleware } from 'redux-observable';
import { rootEpic } from './RootEpic';
import createBrowserHistory from 'history/createBrowserHistory';
import { routerMiddleware } from 'connected-react-router';
import { composeWithDevTools } from 'redux-devtools-extension';
import { Action } from 'redux-actions';
import { StoreState } from './StoreState';

const epicMiddleware = createEpicMiddleware<Action<any>, Action<any>, StoreState, any>();

export const history = createBrowserHistory();

const routesMiddleware = routerMiddleware(history);

export function configureStore() {
    const store = createStore(
        createRootReducer(history),
        composeWithDevTools(applyMiddleware(routesMiddleware, epicMiddleware)),
    );
    epicMiddleware.run(rootEpic);
    return store;
}


// WEBPACK FOOTER //
// ./src/store/AppStore.ts